import { render, staticRenderFns } from "./CadastroApoiadoPortalAba.vue?vue&type=template&id=d8f59bd6&"
import script from "./CadastroApoiadoPortalAba.vue?vue&type=script&lang=js&"
export * from "./CadastroApoiadoPortalAba.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports